import { toast } from "sonner";
import { pendenciasErp, type ResultadoEnvioErp } from "@/data/erp";

/** Toast do lançamento no ERP — usado no fechamento e no reenvio. */
export function avisarResultadoErp(r: ResultadoEnvioErp | undefined) {
  if (!r) return;
  // Sem strictNullChecks o TS não estreita por `!r.ok`.
  if (r.ok === false) {
    toast.error("Não foi possível lançar no ERP", {
      description: `${r.mensagem}. Tente de novo pela aba ERP.`,
    });
    return;
  }
  const pendentes = pendenciasErp(r.lancamentos);
  if (pendentes > 0) {
    toast.warning(`Lançado no ERP com ${pendentes} pendência(s)`, {
      description: "Veja os erros e avisos na aba ERP.",
    });
  } else {
    toast.success(`${r.resumo.total} conta(s) a pagar lançada(s) no ERP`);
  }
}
